import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaCheckCircle, FaExclamationTriangle, FaTimesCircle, FaInfoCircle, FaTimes } from 'react-icons/fa';

const ToastContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: calc(100vw - 2rem);
  box-sizing: border-box;

  @media (max-width: 768px) {
    left: 1rem;
    right: 1rem;
    top: 12px;
    max-width: none;
  }
`;

const ToastItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 300px;
  max-width: 400px;
  animation: slideIn 0.3s ease-out;
  border-left: 4px solid;
  box-sizing: border-box;

  @media (max-width: 768px) {
    min-width: 0;
    max-width: 100%;
    width: 100%;
    padding: 12px 14px;
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  &.success {
    background: #d4edda;
    color: #155724;
    border-left-color: #28a745;
  }

  &.error {
    background: #f8d7da;
    color: #721c24;
    border-left-color: #dc3545;
  }

  &.warning {
    background: #fff3cd;
    color: #856404;
    border-left-color: #ffc107;
  }

  &.info {
    background: #d1ecf1;
    color: #0c5460;
    border-left-color: #17a2b8;
  }

  .toast-icon {
    font-size: 1.2rem;
    flex-shrink: 0;
  }

  .toast-content {
    flex: 1;
    font-weight: 500;
    font-size: 0.95rem;
  }

  .toast-action {
    flex-shrink: 0;
    padding: 4px 10px;
    border: 1px solid currentColor;
    border-radius: 6px;
    color: inherit;
    font-size: 0.8125rem;
    font-weight: 600;
    text-decoration: none;
    white-space: nowrap;
    opacity: 0.9;
    transition: opacity 0.15s ease, background-color 0.15s ease;

    &:hover {
      opacity: 1;
      background: rgba(255, 255, 255, 0.35);
    }
  }

  .toast-close {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    opacity: 0.7;
    transition: opacity 0.2s;
    flex-shrink: 0;

    &:hover {
      opacity: 1;
    }
  }
`;

const Toast = ({ toasts, removeToast }) => {
  return (
    <ToastContainer>
      {toasts.map((toast) => (
        <ToastItem key={toast.id} className={toast.type}>
          <div className="toast-icon">
            {toast.type === 'success' && <FaCheckCircle />}
            {toast.type === 'error' && <FaTimesCircle />}
            {toast.type === 'warning' && <FaExclamationTriangle />}
            {toast.type === 'info' && <FaInfoCircle />}
          </div>
          <div className="toast-content">{toast.message}</div>
          {toast.action ? (
            <Link
              className="toast-action"
              to={toast.action.to}
              onClick={() => removeToast(toast.id)}
            >
              {toast.action.label}
            </Link>
          ) : null}
          <button 
            className="toast-close" 
            onClick={() => removeToast(toast.id)}
            aria-label="Fechar notificação"
          >
            <FaTimes />
          </button>
        </ToastItem>
      ))}
    </ToastContainer>
  );
};

export default Toast; 